// extracted by mini-css-extract-plugin
export var container = "contactDisplay-module--container--8f2ff";
export var form = "contactDisplay-module--form--a66a9";
export var heading = "contactDisplay-module--heading--5e588";